import { LANGUAGE } from '@common/constants/global.constants'
import { CertificationCourse } from '@common/enums/certification.enums'
import {
	CompanyCountry,
	CompanyType
} from '@common/enums/company.enums'
import { Status } from '@common/enums/global.enums'
import { Route } from '@config/routes/routes.enums'
import { flatten } from 'flat'

const messages = {
	global: {
		buttons: {
			apply: 'Apply',
			cancel: 'Cancel',
			clear: 'Clear',
			confirm: 'Confirm',
			create: 'Create',
			delete: 'Delete',
			download: 'Download',
			export: 'Export',
			update: 'Update'
		},
		enums: {
			certificationCourse: {
				[CertificationCourse.HALF_DAY_SBEX_HIGH_PRESSURE]: 'Half-day SBEx High Pressure',
				[CertificationCourse.HALF_DAY_SBEX_LOW_PRESSURE]: 'Half-day SBEx Low Pressure',
				[CertificationCourse.SBEX_HIGH_PRESSURE]: 'SBEx High Pressure',
				[CertificationCourse.SBEX_LOW_PRESSURE]: 'SBEx Low Pressure',
				[CertificationCourse.SBEX_MPI]: 'SBEx Mpi',
				[CertificationCourse.SBEX_PHASTITE]: 'SBEx Phastite'
			},
			companyCountry: {
				[CompanyCountry.AFGHANISTAN]: 'Afghanistan',
				[CompanyCountry.ALBANIA]: 'Albania',
				[CompanyCountry.ALGERIA]: 'Algeria',
				[CompanyCountry.ANDORRA]: 'Andorra',
				[CompanyCountry.ANGOLA]: 'Angola',
				[CompanyCountry.ANTIGUA_AND_BARBUDA]: 'Antigua and Barbuda',
				[CompanyCountry.ARGENTINA]: 'Argentina',
				[CompanyCountry.ARMENIA]: 'Armenia',
				[CompanyCountry.AUSTRALIA]: 'Australia',
				[CompanyCountry.AUSTRIA]: 'Austria',
				[CompanyCountry.AZERBAIJAN]: 'Azerbaijan',
				[CompanyCountry.BAHAMAS]: 'Bahamas',
				[CompanyCountry.BAHRAIN]: 'Bahrain',
				[CompanyCountry.BANGLADESH]: 'Bangladesh',
				[CompanyCountry.BARBADOS]: 'Barbados',
				[CompanyCountry.BELARUS]: 'Belarus',
				[CompanyCountry.BELGIUM]: 'Belgium',
				[CompanyCountry.BELIZE]: 'Belize',
				[CompanyCountry.BENIN]: 'Benin',
				[CompanyCountry.BHUTAN]: 'Bhutan',
				[CompanyCountry.BOLIVIA]: 'Bolivia',
				[CompanyCountry.BOSNIA_AND_HERZEGOVINA]: 'Bosnia and Herzegovina',
				[CompanyCountry.BOTSWANA]: 'Botswana',
				[CompanyCountry.BRAZIL]: 'Brazil',
				[CompanyCountry.BRUNEI]: 'Brunei',
				[CompanyCountry.BULGARIA]: 'Bulgaria',
				[CompanyCountry.BURKINA_FASO]: 'Burkina Faso',
				[CompanyCountry.BURUNDI]: 'Burundi',
				[CompanyCountry.CABO_VERDE]: 'Cabo Verde',
				[CompanyCountry.CAMBODIA]: 'Cambodia',
				[CompanyCountry.CAMEROON]: 'Cameroon',
				[CompanyCountry.CANADA]: 'Canada',
				[CompanyCountry.CENTRAL_AFRICAN_REPUBLIC]: 'Central African Republic',
				[CompanyCountry.CHAD]: 'Chad',
				[CompanyCountry.CHILE]: 'Chile',
				[CompanyCountry.CHINA]: 'China',
				[CompanyCountry.COLOMBIA]: 'Colombia',
				[CompanyCountry.COMOROS]: 'Comoros',
				[CompanyCountry.CONGO]: 'Congo',
				[CompanyCountry.COSTA_RICA]: 'Costa Rica',
				[CompanyCountry.CROATIA]: 'Croatia',
				[CompanyCountry.CUBA]: 'Cuba',
				[CompanyCountry.CYPRUS]: 'Cyprus',
				[CompanyCountry.CZECH_REPUBLIC]: 'Czech Republic',
				[CompanyCountry.DEMOCRATIC_REPUBLIC_OF_THE_CONGO]: 'Democratic Republic of the Congo',
				[CompanyCountry.DENMARK]: 'Denmark',
				[CompanyCountry.DJIBOUTI]: 'Djibouti',
				[CompanyCountry.DOMINICA]: 'Dominica',
				[CompanyCountry.DOMINICAN_REPUBLIC]: 'Dominican Republic',
				[CompanyCountry.ECUADOR]: 'Ecuador',
				[CompanyCountry.EGYPT]: 'Egypt',
				[CompanyCountry.EL_SALVADOR]: 'El Salvador',
				[CompanyCountry.EQUATORIAL_GUINEA]: 'Equatorial Guinea',
				[CompanyCountry.ERITREA]: 'Eritrea',
				[CompanyCountry.ESTONIA]: 'Estonia',
				[CompanyCountry.ESWATINI]: 'Eswatini',
				[CompanyCountry.ETHIOPIA]: 'Ethiopia',
				[CompanyCountry.FIJI]: 'Fiji',
				[CompanyCountry.FINLAND]: 'Finland',
				[CompanyCountry.FRANCE]: 'France',
				[CompanyCountry.GABON]: 'Gabon',
				[CompanyCountry.GAMBIA]: 'Gambia',
				[CompanyCountry.GEORGIA]: 'Georgia',
				[CompanyCountry.GERMANY]: 'Germany',
				[CompanyCountry.GHANA]: 'Ghana',
				[CompanyCountry.GREECE]: 'Greece',
				[CompanyCountry.GRENADA]: 'Grenada',
				[CompanyCountry.GUATEMALA]: 'Guatemala',
				[CompanyCountry.GUINEA]: 'Guinea',
				[CompanyCountry.GUINEA_BISSAU]: 'Guinea-Bissau',
				[CompanyCountry.GUYANA]: 'Guyana',
				[CompanyCountry.HAITI]: 'Haiti',
				[CompanyCountry.HONDURAS]: 'Honduras',
				[CompanyCountry.HUNGARY]: 'Hungary',
				[CompanyCountry.ICELAND]: 'Iceland',
				[CompanyCountry.INDIA]: 'India',
				[CompanyCountry.INDONESIA]: 'Indonesia',
				[CompanyCountry.IRAN]: 'Iran',
				[CompanyCountry.IRAQ]: 'Iraq',
				[CompanyCountry.IRELAND]: 'Ireland',
				[CompanyCountry.ISRAEL]: 'Israel',
				[CompanyCountry.ITALY]: 'Italy',
				[CompanyCountry.JAMAICA]: 'Jamaica',
				[CompanyCountry.JAPAN]: 'Japan',
				[CompanyCountry.JORDAN]: 'Jordan',
				[CompanyCountry.KAZAKHSTAN]: 'Kazakhstan',
				[CompanyCountry.KENYA]: 'Kenya',
				[CompanyCountry.KIRIBATI]: 'Kiribati',
				[CompanyCountry.KUWAIT]: 'Kuwait',
				[CompanyCountry.KYRGYZSTAN]: 'Kyrgyzstan',
				[CompanyCountry.LAOS]: 'Laos',
				[CompanyCountry.LATVIA]: 'Latvia',
				[CompanyCountry.LEBANON]: 'Lebanon',
				[CompanyCountry.LESOTHO]: 'Lesotho',
				[CompanyCountry.LIBERIA]: 'Liberia',
				[CompanyCountry.LIBYA]: 'Libya',
				[CompanyCountry.LIECHTENSTEIN]: 'Liechtenstein',
				[CompanyCountry.LITHUANIA]: 'Lithuania',
				[CompanyCountry.LUXEMBOURG]: 'Luxembourg',
				[CompanyCountry.MADAGASCAR]: 'Madagascar',
				[CompanyCountry.MALAWI]: 'Malawi',
				[CompanyCountry.MALAYSIA]: 'Malaysia',
				[CompanyCountry.MALDIVES]: 'Maldives',
				[CompanyCountry.MALI]: 'Mali',
				[CompanyCountry.MALTA]: 'Malta',
				[CompanyCountry.MARSHALL_ISLANDS]: 'Marshall Islands',
				[CompanyCountry.MAURITANIA]: 'Mauritania',
				[CompanyCountry.MAURITIUS]: 'Mauritius',
				[CompanyCountry.MEXICO]: 'Mexico',
				[CompanyCountry.MICRONESIA]: 'Micronesia',
				[CompanyCountry.MOLDOVA]: 'Moldova',
				[CompanyCountry.MONACO]: 'Monaco',
				[CompanyCountry.MONGOLIA]: 'Mongolia',
				[CompanyCountry.MONTENEGRO]: 'Montenegro',
				[CompanyCountry.MOROCCO]: 'Morocco',
				[CompanyCountry.MOZAMBIQUE]: 'Mozambique',
				[CompanyCountry.MYANMAR]: 'Myanmar',
				[CompanyCountry.NAMIBIA]: 'Namibia',
				[CompanyCountry.NAURU]: 'Nauru',
				[CompanyCountry.NEPAL]: 'Nepal',
				[CompanyCountry.NETHERLANDS]: 'Netherlands',
				[CompanyCountry.NEW_ZEALAND]: 'New Zealand',
				[CompanyCountry.NICARAGUA]: 'Nicaragua',
				[CompanyCountry.NIGER]: 'Niger',
				[CompanyCountry.NIGERIA]: 'Nigeria',
				[CompanyCountry.NORTH_KOREA]: 'North Korea',
				[CompanyCountry.NORTH_MACEDONIA]: 'North Macedonia',
				[CompanyCountry.NORWAY]: 'Norway',
				[CompanyCountry.OMAN]: 'Oman',
				[CompanyCountry.PAKISTAN]: 'Pakistan',
				[CompanyCountry.PALAU]: 'Palau',
				[CompanyCountry.PALESTINE]: 'Palestine',
				[CompanyCountry.PANAMA]: 'Panama',
				[CompanyCountry.PAPUA_NEW_GUINEA]: 'Papua New Guinea',
				[CompanyCountry.PARAGUAY]: 'Paraguay',
				[CompanyCountry.PERU]: 'Peru',
				[CompanyCountry.PHILIPPINES]: 'Philippines',
				[CompanyCountry.POLAND]: 'Poland',
				[CompanyCountry.PORTUGAL]: 'Portugal',
				[CompanyCountry.QATAR]: 'Qatar',
				[CompanyCountry.ROMANIA]: 'Romania',
				[CompanyCountry.RUSSIA]: 'Russia',
				[CompanyCountry.RWANDA]: 'Rwanda',
				[CompanyCountry.SAINT_KITTS_AND_NEVIS]: 'Saint Kitts and Nevis',
				[CompanyCountry.SAINT_LUCIA]: 'Saint Lucia',
				[CompanyCountry.SAINT_VINCENT_AND_THE_GRENADINES]: 'Saint Vincent and the Grenadines',
				[CompanyCountry.SAMOA]: 'Samoa',
				[CompanyCountry.SAN_MARINO]: 'San Marino',
				[CompanyCountry.SAO_TOME_AND_PRINCIPE]: 'Sao Tome and Principe',
				[CompanyCountry.SAUDI_ARABIA]: 'Saudi Arabia',
				[CompanyCountry.SENEGAL]: 'Senegal',
				[CompanyCountry.SERBIA]: 'Serbia',
				[CompanyCountry.SEYCHELLES]: 'Seychelles',
				[CompanyCountry.SIERRA_LEONE]: 'Sierra Leone',
				[CompanyCountry.SINGAPORE]: 'Singapore',
				[CompanyCountry.SLOVAKIA]: 'Slovakia',
				[CompanyCountry.SLOVENIA]: 'Slovenia',
				[CompanyCountry.SOLOMON_ISLANDS]: 'Solomon Islands',
				[CompanyCountry.SOMALIA]: 'Somalia',
				[CompanyCountry.SOUTH_AFRICA]: 'South Africa',
				[CompanyCountry.SOUTH_KOREA]: 'South Korea',
				[CompanyCountry.SOUTH_SUDAN]: 'South Sudan',
				[CompanyCountry.SPAIN]: 'Spain',
				[CompanyCountry.SRI_LANKA]: 'Sri Lanka',
				[CompanyCountry.SUDAN]: 'Sudan',
				[CompanyCountry.SURINAME]: 'Suriname',
				[CompanyCountry.SWEDEN]: 'Sweden',
				[CompanyCountry.SWITZERLAND]: 'Switzerland',
				[CompanyCountry.SYRIA]: 'Syria',
				[CompanyCountry.TAIWAN]: 'Taiwan',
				[CompanyCountry.TAJIKISTAN]: 'Tajikistan',
				[CompanyCountry.TANZANIA]: 'Tanzania',
				[CompanyCountry.THAILAND]: 'Thailand',
				[CompanyCountry.TIMOR_LESTE]: 'Timor-Leste',
				[CompanyCountry.TOGO]: 'Togo',
				[CompanyCountry.TONGA]: 'Tonga',
				[CompanyCountry.TRINIDAD_AND_TOBAGO]: 'Trinidad and Tobago',
				[CompanyCountry.TUNISIA]: 'Tunisia',
				[CompanyCountry.TURKEY]: 'Turkey',
				[CompanyCountry.TURKMENISTAN]: 'Turkmenistan',
				[CompanyCountry.TUVALU]: 'Tuvalu',
				[CompanyCountry.UGANDA]: 'Uganda',
				[CompanyCountry.UKRAINE]: 'Ukraine',
				[CompanyCountry.UNITED_ARAB_EMIRATES]: 'United Arab Emirates',
				[CompanyCountry.UNITED_KINGDOM]: 'United Kingdom',
				[CompanyCountry.UNITED_STATES_OF_AMERICA]: 'United States of America',
				[CompanyCountry.URUGUAY]: 'Uruguay',
				[CompanyCountry.UZBEKISTAN]: 'Uzbekistan',
				[CompanyCountry.VANUATU]: 'Vanuatu',
				[CompanyCountry.VATICAN_CITY]: 'Vatican City',
				[CompanyCountry.VENEZUELA]: 'Venezuela',
				[CompanyCountry.VIETNAM]: 'Vietnam',
				[CompanyCountry.YEMEN]: 'Yemen',
				[CompanyCountry.ZAMBIA]: 'Zambia',
				[CompanyCountry.ZIMBABWE]: 'Zimbabwe'
			},
			companyType: {
				[CompanyType.DISTRIBUTOR]: 'Distributor',
				[CompanyType.DIVISION]: 'Division',
				[CompanyType.END_USER]: 'End user',
				[CompanyType.SALES_COMPANY]: 'Sales Co'
			},
			status: {
				[Status.ACTIVE]: 'Active',
				[Status.INACTIVE]: 'Inactive',
				[Status.DELETED]: 'Deleted'
			}
		},
		errorPages: {
			forbidden: {
				code: '403',
				message: 'Page forbidden',
				explanation: 'The page you are looking for is not accessible.'
			},
			notFound: {
				code: '404',
				message: 'Page not found',
				explanation: 'The page you are looking for does not exist or is not currently available.'
			},
			unauthorized: {
				code: '401',
				message: 'Unauthorized',
				explanation: 'You are not authorized to access the requested page.'
			}
		},
		errors: {
			certificationAlreadyCreated: 'Certification already created for this trainee',
			emailAlreadyUsed: 'Email already used. It must be unique',
			occurred: 'An error occurred',
			pattern: 'Wrong format',
			required: 'Required field',
			traineeHasNoEmail: 'A trainer must have an email'
		},
		fields: {
			company: 'Company',
			country: 'Country',
			course: 'Course',
			email: 'Email',
			firstname: 'Firstname',
			lastname: 'Lastname',
			name: 'Name',
			status: 'Status',
			trainer: 'Trainer',
			type: 'Type'
		},
		lang: LANGUAGE,
		tabs: {
			[Route.DASHBOARD]: 'SBEx dashboard',
			[Route.TRAINEES]: 'SBEx trainees management',
			[Route.ANALYTICS]: 'SBEx analytics'
		}
	},
	components: {
		certificationPopIn: {
			creation: {
				title: 'New certification',
				subtitle: 'Enter the training details to generate the certificate.',
				buttons: {
					confirm: {
						label: 'Create certification'
					}
				},
				success: 'The certification has been created'
			},
			fields: {
				trainer: {
					placeholder: 'Select a trainer',
					noData: 'No active trainers'
				},
				course: {
					placeholder: 'Select a course'
				},
				isTrainer: {
					label: 'Obtain as a trainer'
				},
				date: {
					label: 'Training date',
					placeholder: 'Select a date'
				}
			}
		}
	},
	dashboard: {
		expiringCertifications: {
			title: '<a><b>{count} expiring {count, plural, =0 {certification} one {certification} other {certifications}}</b><c>(in 3 months or less)</c></a>',
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				trainer: 'Trainer',
				date: 'Expires on {date}',
				discardButton: {
					label: 'Discard',
					success: 'Notification has been discard'
				},
				noData: 'No expiring certifications'
			}
		},
		trainees: {
			title: 'Trainees management',
			actions: {
				addTrainee: {
					label: 'New trainee',
					title: 'New trainee',
					subtitle: 'Add a trainee so you can issue them a certificate. ',
					fields: {
						email: {
							label: 'Email (mandatory for trainers)'
						},
						company: {
							placeholder: 'Select a company'
						}
					},
					buttons: {
						create: 'Create trainee',
						createWithCertification: 'Create trainee and add certification'
					},
					success: 'The trainee has been created'
				},
				addCompany: {
					title: 'Select a company',
					subtitle: 'Search for the trainee’s company or add it if it isn’t listed.',
					filters: {
						query: {
							placeholder: 'Start typing a company name'
						}
					},
					links: {
						createCompany: '<a><b>Company does not exist?</b> <c><b>Click here to create</b></c></a>'
					},
					noData: 'No companies'
				},
				createCompany: {
					title: 'New company',
					subtitle: 'Create a new company to use in trainee records.',
					fields: {
						type: {
							placeholder: 'Select company type'
						},
						country: {
							placeholder: 'Select a country'
						},
						name: {
							placeholder: 'Company name'
						}
					},
					buttons: {
						confirm: {
							label: 'Create company'
						}
					},
					success: 'The company has been created'
				}
			},
			filters: {
				company: 'Select company',
				companiesNotFound: 'No companies found',
				query: 'Name, mail or certificate number',
				advanced: {
					title: 'Advanced filters',
					subtitle: 'Filter certificates by course and/or date range.',
					course: {
						title: 'Course',
						select: 'Select a course'
					},
					startDate: 'Training date from',
					endDate: 'To'
				}
			},
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				actions: {
					viewUpdate: {
						label: 'View & update'
					},
					addCertification: {
						label: 'Add certification'
					}
				},
				noData: 'No trainees'
			}
		},
		tooltips: {
			viewTraineeDetails: 'Use CTRL+click to view trainee\'s details in new tab'
		}
	},
	trainee: {
		information: {
			buttons: {
				save: {
					label: 'Save changes',
					success: 'The trainee information has been saved'
				},
				delete: {
					title: 'Delete trainee',
					message: 'Confirm trainee’s deletion?',
					success: 'The trainee has been deleted'
				}
			}
		},
		certifications: {
			header: {
				title: 'Certifications'
			},
			actions: {
				create: {
					label: 'New certification'
				},
				update: {
					title: 'Amend certification',
					subtitle: 'Review and edit details before generating the certificate.',
					buttons: {
						confirm: {
							label: 'Save Changes'
						}
					},
					success: 'The certification has been updated'
				},
				delete: {
					title: 'Delete certification',
					message: 'Confirm certification\'s deletion ?',
					success: 'The certification has been deleted'
				}
			},
			list: {
				trainer: 'Trainer',
				training: 'Trained on {date} by {trainer} / {company}',
				expiringDate: 'Expires on {date}',
				noData: 'No certifications',
				download: {
					label: 'Download certificate'
				}
			}
		}
	},
	analytics: {
		title: 'Analytics data',
		inputs: {
			startDate: {
				label: 'Start date selection'
			},
			endDate: {
				label: 'End date selection'
			}
		}
	}
}

const appMessages: Record<string, string> = flatten(messages)

export default appMessages
